var KeepaliveSvc = (function () {
    function KeepaliveSvc() {
    }
    return KeepaliveSvc;
}());
export { KeepaliveSvc };
//# sourceMappingURL=keepalivesvc.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/@ng-idle/core/src/keepalivesvc.js
// module id = ../../../../@ng-idle/core/src/keepalivesvc.js
// module chunks = 4